import React, { useState } from 'react';  // Importing React and useState hook from React
import { FaGlobe, FaFolderOpen } from 'react-icons/fa';  // Importing icons for globe and folder

const Activity = () => {
  // State to handle dropdown visibility
  const [showDropdown, setShowDropdown] = useState(false);

  // Function to toggle dropdown visibility
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // Array of activity data to be displayed
  const activities = [
    {
      date: 'Yesterday', // Date of the activity
      items: [
        {
          icon: <FaFolderOpen />, // Icon for the activity
          text: 'Case #33369', // Main activity text
          url: '#', // URL to link to
          description: 'for', // Short description
          linkedText: 'ALL SAINTS DENTAL', // Linked text
          linkedUrl: '#', // URL for linked text
          caseText: 'Lyon Marianne', // Case-related text
          caseUrl: '#', // URL for case
          extra: 'Case rescheduled to be sent on 8 Mar 2025' // Additional info
        },
        // Other activity items follow the same structure
      ]
    },
    // Another date group with activity items
    {
      date: '7 Mar 2025',
      items: [
        // List of items for this date
      ]
    }
  ];

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}>
      {/* View All Dropdown */}
      <div style={{ position: 'relative', marginBottom: '20px' }}>
        {/* Label and Button for dropdown */}
        <label style={{ fontWeight: 'bold', marginRight: '10px' }}>View</label>
        <button 
          onClick={toggleDropdown} // Toggle dropdown on click
          style={{ padding: '5px 10px', background: 'white', border: '1px solid #ccc', cursor: 'pointer', borderRadius: '5px' }}
        >
          <FaGlobe /> All ▼  {/* Display the globe icon and label */}
        </button>
        {/* Dropdown menu */}
        {showDropdown && (
          <div style={{ position: 'absolute', background: 'white', border: '1px solid #ccc', padding: '10px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)', zIndex: 10 }}>
            <p><FaGlobe /> All - All Updates</p>
            <p><FaGlobe /> All - Accounts - Account Updates Only</p>
            <p><FaGlobe /> All - Lab - Lab Updates Only</p>
            <p><FaFolderOpen /> Cases Created - All Updates</p>
          </div>
        )}
      </div>
      
      {/* Mapping through activity data */}
      {activities.map((activity, index) => (
        <div key={index} style={{ marginBottom: '20px' }}>
          <h3 style={{ fontSize: '16px', marginBottom: '10px' }}>{activity.date}</h3> {/* Display activity date */}
          
          {/* Mapping through items in each activity */}
          {activity.items.map((item, idx) => (
            <div key={idx} style={{ marginBottom: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {/* Display icon and activity details */}
                <span style={{ marginRight: '8px', color: '#555' }}>{item.icon}</span>
                <a href={item.url} style={{ color: '#0056b3', textDecoration: 'none', fontWeight: 'bold', marginRight: '5px' }}>{item.text}</a>
                <span style={{ marginRight: '5px' }}>{item.description}</span>
                <a href={item.linkedUrl} style={{ color: '#0056b3', textDecoration: 'none', fontWeight: 'bold', marginRight: '5px' }}>{item.linkedText}</a>
                {item.caseText && <a href={item.caseUrl} style={{ color: '#0056b3', textDecoration: 'none', fontWeight: 'bold', marginLeft: '5px' }}>{item.caseText}</a>}
              </div>
              {/* Display extra info if available */}
              {item.extra && <div style={{ fontStyle: 'italic', color: 'gray', marginLeft: '25px' }}>{item.extra}</div>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Activity;
